export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=21cfbb86"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/view/index.vue?vue&type=template&id=21cfbb86
// module id = 7S5o
// module chunks = 0